import { Notifications, Reminder, ReminderBasedOn } from '@griply/types';

import { getDefaultTaskReminder } from './get-default-task-reminder';
import { sortReminders } from './reminder-list';

export type GetDisplayedTaskRemindersOptions = {
  notifications: Notifications | undefined;
  hasDate: boolean;
  hasTime: boolean;
};

// An absent list falls back to the user's default; an empty one is a deliberate opt-out.
export const getDisplayedTaskReminders = (
  reminders: Reminder[] | null | undefined,
  { notifications, hasDate, hasTime }: GetDisplayedTaskRemindersOptions,
): Reminder[] => {
  if (reminders != null) {
    return sortReminders(reminders);
  }

  // Nothing anchors a reminder without a date, so the default stays hidden.
  if (!hasDate) {
    return [];
  }

  const defaultReminder = getDefaultTaskReminder(
    notifications,
    hasTime ? ReminderBasedOn.Start : ReminderBasedOn.DayStart,
  );

  return defaultReminder ? [defaultReminder] : [];
};
